module.exports = __webpack_public_path__ + "img/television.0551950a.svg";